// extracted by mini-css-extract-plugin
export default {"multiline-ellipsis":"MultiLineEllipsis_multiline-ellipsis__hyxdh"};